var map = {
	"./icon-arrow-down.svg": "e0c5",
	"./icon-arrow-fat-down.svg": "1f40",
	"./icon-arrow-fat-left.svg": "daf3",
	"./icon-arrow-fat-right.svg": "7ba3",
	"./icon-arrow-fat-up.svg": "50a1",
	"./icon-arrow-green.svg": "8b59",
	"./icon-arrow-left.svg": "3b98",
	"./icon-arrow-right.svg": "2115",
	"./icon-arrow-up.svg": "47e8",
	"./icon-arrows-chevron-left.svg": "1dfe",
	"./icon-arrows-chevron-right.svg": "a39d",
	"./icon-bag.svg": "9be5",
	"./icon-bell-badge-fill.svg": "fc51",
	"./icon-bell-badge.svg": "e062",
	"./icon-bell-fill.svg": "c577",
	"./icon-bell.svg": "7744",
	"./icon-breadcrumb.svg": "6664",
	"./icon-check-circle-fill.svg": "9d69",
	"./icon-check-circle.svg": "6324",
	"./icon-check-mark.svg": "dfe7",
	"./icon-check.svg": "dc7b",
	"./icon-chevron-down.svg": "0782",
	"./icon-chevron-left.svg": "a30b",
	"./icon-chevron-right.svg": "eeb9",
	"./icon-chevron-up.svg": "354e",
	"./icon-clock-fill.svg": "d973",
	"./icon-clock.svg": "40a9",
	"./icon-close-circle-fill.svg": "6947",
	"./icon-close-circle.svg": "3152",
	"./icon-close-colored.svg": "fdc1",
	"./icon-close.svg": "3324",
	"./icon-controls-backward.svg": "01af",
	"./icon-controls-first-page.svg": "cccd",
	"./icon-controls-forward.svg": "0d15",
	"./icon-controls-last-page.svg": "8b60",
	"./icon-dashboard.svg": "4b97",
	"./icon-doc-magnifier.svg": "3acb",
	"./icon-document.svg": "911b",
	"./icon-dots-horizontal.svg": "ab82",
	"./icon-dots-vertical.svg": "4109",
	"./icon-email-fill.svg": "c64f",
	"./icon-email.svg": "477a",
	"./icon-error.svg": "f519",
	"./icon-excel-export.svg": "9da9",
	"./icon-eye-closed.svg": "74b2",
	"./icon-eye-open.svg": "9c91",
	"./icon-file-box-dark.svg": "22e5",
	"./icon-file-box.svg": "0d50",
	"./icon-filter.svg": "8fab",
	"./icon-gear-fill.svg": "2f95",
	"./icon-gear.svg": "03cd",
	"./icon-green-info.svg": "0257",
	"./icon-green-link.svg": "dd51",
	"./icon-home.svg": "3c44",
	"./icon-hourglass.svg": "b797",
	"./icon-info.svg": "6100",
	"./icon-loader.svg": "70ac",
	"./icon-login.svg": "5885",
	"./icon-logo.svg": "1b9a",
	"./icon-logout.svg": "a8aa",
	"./icon-menu.svg": "2cf5",
	"./icon-month-closing-dark.svg": "cd68",
	"./icon-month-closing-white.svg": "34f7",
	"./icon-no-image.svg": "7090",
	"./icon-no-user.svg": "8f5e",
	"./icon-order-arrow-down.svg": "d0f6",
	"./icon-order-arrow-up.svg": "bc2f",
	"./icon-password.svg": "ae9c",
	"./icon-pause.svg": "e802",
	"./icon-pen.svg": "33e5",
	"./icon-person-fill.svg": "b511",
	"./icon-person.svg": "5d28",
	"./icon-persons-fill.svg": "adfc",
	"./icon-persons.svg": "5886",
	"./icon-phone-circle-fill.svg": "4766",
	"./icon-phone-circle.svg": "09b6",
	"./icon-phone-fill.svg": "a916",
	"./icon-phone.svg": "3ff5",
	"./icon-play-fill.svg": "dcb3",
	"./icon-play.svg": "1960",
	"./icon-plus-circle.svg": "d3ca",
	"./icon-plus.svg": "a3b7",
	"./icon-question-fill.svg": "716e",
	"./icon-question.svg": "e3ba",
	"./icon-red-info.svg": "30d9",
	"./icon-repres-calender.svg": "8d3f",
	"./icon-search-user.svg": "e4bc",
	"./icon-search.svg": "6819",
	"./icon-settings-horizontal.svg": "2a76",
	"./icon-settings-vertical.svg": "76a4",
	"./icon-settings.svg": "1f26",
	"./icon-success.svg": "0212",
	"./icon-tasks.svg": "fbc2",
	"./icon-triangle-down.svg": "5253",
	"./icon-triangle-left.svg": "8d2e",
	"./icon-triangle-right.svg": "5a4d",
	"./icon-triangle-up.svg": "f819",
	"./icon-two-arrows-chevron-left.svg": "7eb0",
	"./icon-two-arrows-chevron-right.svg": "d3e5",
	"./icon-under-construction.svg": "3a03",
	"./icon-user.svg": "e7c2",
	"./icon-warn-yellow.svg": "6d15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0057";